import { Table, Tbody, Text, Th, Thead, Tr } from '@chakra-ui/react';
import { Product } from 'shared/models/product';
import PlanTableLine from '../molecules/PlanTableLine';

interface ContractPlansTableProps {
  loading?: boolean;
  plans?: Product[];
}
const ContractPlansTable = ({ loading, plans }: ContractPlansTableProps) => {
  const planSkeletonList = Array.from({ length: 3 });
  return (
    <Table
      variant="simple"
      sx={{
        'thead tr th': {
          fontWeight: 'normal',
          color: '#1A202C',
        },
        'tbody tr td': {
          fontWeight: 'normal',
          color: '#1A202C',
        },
      }}
    >
      <Thead opacity={loading ? '.3' : ''}>
        <Tr>
          <Th>Plano</Th>
          <Th>Valor</Th>
          <Th>Desconto</Th>
          <Th>Ciclos do desconto</Th>
          <Th>Criado em</Th>
          <Th w="10px"></Th>
        </Tr>
      </Thead>
      <Tbody>
        {loading ? (
          planSkeletonList.map((_, index) => (
            <PlanTableLine key={index} loading={true} />
          ))
        ) : plans?.length ? (
          plans.map((plan) => <PlanTableLine key={plan.id} plan={plan} />)
        ) : (
          <Tr>
            <Text my={'0.5rem'}>Nenhum plano encontrado</Text>
          </Tr>
        )}
      </Tbody>
    </Table>
  );
};
export default ContractPlansTable;
